import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Eye, Loader2 } from "lucide-react";

const STATUS_LABEL = { new: "Nova", in_progress: "Em andamento", resolved: "Resolvida", archived: "Arquivada" };

export default function AdminSubmissions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("all");

  const load = () => {
    setLoading(true);
    api.get("/admin/submissions").then((r) => setItems(r.data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/submissions/${id}`, { status });
    toast.success("Status atualizado");
    load();
    setSelected((s) => (s && s.id === id ? { ...s, status } : s));
  };

  const remove = async (id) => {
    if (!window.confirm("Excluir esta mensagem?")) return;
    await api.delete(`/admin/submissions/${id}`);
    toast.success("Excluída");
    load();
    setSelected(null);
  };

  const filtered = filter === "all" ? items : items.filter((i) => i.status === filter);

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-serif text-3xl text-[color:var(--marupiara-gold)]">Formulários recebidos</h1>
        <p className="text-white/60 text-sm mt-1">{items.length} mensagem(ns)</p>
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        {["all", "new", "in_progress", "resolved", "archived"].map((s) => (
          <button key={s} onClick={() => setFilter(s)} className={`px-4 py-2 text-xs uppercase tracking-wider ${filter === s ? "bg-[color:var(--marupiara-gold)] text-[color:var(--marupiara-obsidian)]" : "bg-[color:var(--marupiara-charcoal)] text-white/70 border border-white/10"}`}>
            {s === "all" ? "Todas" : STATUS_LABEL[s]}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-white/60"><Loader2 size={16} className="animate-spin" /> Carregando…</div>
      ) : (
        <div className="bg-[color:var(--marupiara-charcoal)] border border-white/10 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-left text-white/60 uppercase text-xs">
              <tr>
                <th className="px-4 py-3">Nome</th>
                <th className="px-4 py-3">E-mail</th>
                <th className="px-4 py-3">Assunto/Tipo</th>
                <th className="px-4 py-3">Data</th>
                <th className="px-4 py-3">Status</th>
                <th className="px-4 py-3 text-right">Ações</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((s) => (
                <tr key={s.id} className="border-t border-white/5 hover:bg-white/[0.03]">
                  <td className="px-4 py-3 text-white">{s.name}</td>
                  <td className="px-4 py-3 text-white/70">{s.email}</td>
                  <td className="px-4 py-3 text-white/70">{s.subject || s.form_type}</td>
                  <td className="px-4 py-3 text-white/70 text-xs">{new Date(s.created_at).toLocaleString("pt-BR")}</td>
                  <td className="px-4 py-3">
                    <select value={s.status} onChange={(e) => updateStatus(s.id, e.target.value)} className="bg-black/30 border border-white/10 text-white/80 text-xs px-2 py-1">
                      {Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </td>
                  <td className="px-4 py-3 text-right whitespace-nowrap">
                    <button onClick={() => setSelected(s)} className="p-2 text-white/70 hover:text-[color:var(--marupiara-gold)]"><Eye size={14} /></button>
                    <button onClick={() => remove(s.id)} className="p-2 text-white/70 hover:text-red-400"><Trash2 size={14} /></button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan="6" className="text-center py-8 text-white/70">Nenhuma mensagem.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {selected && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setSelected(null)}>
          <div className="bg-[color:var(--marupiara-charcoal)] border border-[color:var(--marupiara-gold)]/30 w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="px-6 py-4 border-b border-white/10">
              <h2 className="font-serif text-2xl text-[color:var(--marupiara-gold)]">{selected.name}</h2>
              <p className="text-white/60 text-sm">{selected.email} — {selected.phone}</p>
            </div>
            <div className="p-6 space-y-4 text-white/85">
              <div><div className="overline text-[10px] text-white/60 mb-1">Tipo</div>{selected.form_type}</div>
              {selected.subject && <div><div className="overline text-[10px] text-white/60 mb-1">Assunto</div>{selected.subject}</div>}
              <div><div className="overline text-[10px] text-white/60 mb-1">Mensagem</div><p className="whitespace-pre-wrap">{selected.message}</p></div>
              <div><div className="overline text-[10px] text-white/60 mb-1">Recebida em</div>{new Date(selected.created_at).toLocaleString("pt-BR")}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
